// External libraries
import gql from 'graphql-tag';

export const CURRENCY_CONVERSION_FROM_CREDIT_CARD_QUERY = gql`
  query CurrencyConversionFromCreditCardQuery(
    $cardBrand: CardIssuerType
    $cardNumber: String!
    $country: CountryCodes
    $token: String!
  ) {
    currencyConversionFromCreditCard(
      cardBrand: $cardBrand
      cardNumber: $cardNumber
      country: $country
      token: $token
    ) {
      canChangeConversionType
      feeRateFormatted
      from {
        currencyCode
        currencyFormatSymbolISOCurrency
      }
      spread
      to {
        currencyCode
        currencyFormatSymbolISOCurrency
      }
      type
    }
  }
`;
